<template>
  <div id="app">
    <Counter />
  </div>
</template>

<script>
import Counter from "@/components/Counter.vue";

export default {
  name: "App",
  components: {
    Counter,
    
  },
};
</script>

<style>
body{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
